(() => {
  if (window.TexanShopping) return;
  const cache = new Map();
  const size = value => {
    const text = String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    if (/rv|shortqueen/.test(text)) return '';
    if (text.includes('splitking')) return 'Split King';
    if (text.includes('california') || text.includes('calking') || text.includes('caking')) return 'California King';
    if (text.includes('twinxl') || text.includes('extralongtwin')) return 'Twin XL';
    for (const name of ['Queen', 'King', 'Full', 'Twin']) if (text.includes(name.toLowerCase())) return name;
    return '';
  };
  const sizeIndex = product => product.options.findIndex(option => option.values.some(value => size(value)));
  const productUrl = (root, handle) => root.replace(/\/?$/, '/') + 'products/' + encodeURIComponent(handle);
  const load = (root, handle) => {
    const key = root + handle;
    if (!cache.has(key)) {
      cache.set(key, fetch(productUrl(root, handle) + '?view=shopping-data', { credentials: 'same-origin', headers: { Accept: 'text/html' } })
        .then(async response => {
          if (!response.ok) throw new Error('Product details could not be loaded.');
          const html = await response.text();
          const data = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-tx-shopping-product-data]');
          const product = JSON.parse(data ? data.textContent : html);
          if (!product.handle || !Array.isArray(product.variants)) throw new Error('Product details could not be loaded.');
          return product;
        }).catch(error => { cache.delete(key); throw error; }));
    }
    return cache.get(key);
  };
  const candidates = (product, selectedSize, allowPair = false) => {
    const index = sizeIndex(product);
    let variants = product.variants.filter(variant => index >= 0 && size(variant.options[index]) === selectedSize);
    let quantity = 1;
    if (!variants.length && selectedSize === 'Split King' && allowPair) {
      variants = product.variants.filter(variant => index >= 0 && size(variant.options[index]) === 'Twin XL');
      quantity = 2;
    }
    return { variants, quantity, index };
  };
  const choose = (variants, preferences = []) => variants.find(variant => variant.available && preferences.every((value, index) => !value || variant.options[index] === value)) ||
    variants.find(variant => preferences.every((value, index) => !value || variant.options[index] === value)) ||
    variants.find(variant => variant.available) || variants[0] || null;
  const money = (cents, currency = 'USD') => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency, maximumFractionDigits: 2 }).format(cents / 100);
  const node = (tag, text, className) => {
    const element = document.createElement(tag);
    if (text !== undefined) element.textContent = text;
    if (className) element.className = className;
    return element;
  };
  const options = (container, product, variants, selected, onChange, prefix) => {
    container.replaceChildren();
    const index = sizeIndex(product);
    product.options.forEach((option, optionIndex) => {
      if (optionIndex === index || option.values.length < 2) return;
      const field = node('div', undefined, 'tx-shopping-option');
      const id = prefix + '-' + optionIndex;
      const label = node('label', option.name); label.htmlFor = id;
      const select = node('select'); select.id = id;
      [...new Set(variants.map(variant => variant.options[optionIndex]))].forEach(value => {
        const entry = node('option', value); entry.value = value;
        const matches = variants.filter(variant => variant.options.every((item, i) => i === optionIndex || item === selected.options[i]));
        entry.disabled = !matches.some(variant => variant.options[optionIndex] === value);
        select.appendChild(entry);
      });
      select.value = selected.options[optionIndex];
      select.addEventListener('change', () => {
        const preferences = [...selected.options]; preferences[optionIndex] = select.value;
        onChange(variants.find(variant => variant.options.every((value, i) => value === preferences[i])) || null);
      });
      field.append(label, select); container.appendChild(field);
    });
  };
  const link = (product, variant) => product.url + (variant ? '?variant=' + variant.id : '');
  window.TexanShopping = { size, sizeIndex, productUrl, load, candidates, choose, money, node, options, link };
})();
